/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { InputLabel, DataLine } from 'components/elements';
import AddressAutocomplete from './AddressAutocomplete';

function AddressAutocompleteControl({ isEditMode, name, control, labelText }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, value = '', ...restField }, fieldState: { error } }) =>
        isEditMode ? (
          <div style={{ marginTop: 20 }}>
            <AddressAutocomplete error={!!error} helperText={error ? error.message : null} value={value} {...restField} label={<InputLabel text={labelText} />} />
          </div>
        ) : (
          <DataLine label={labelText} body={(value || '').description ? value.description : value} />
        )
      }
    />
  );
}

AddressAutocompleteControl.propTypes = {
  labelText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
  control: PropTypes.objectOf(PropTypes.any).isRequired,
};

AddressAutocompleteControl.defaultProps = {
  isEditMode: false,
};

export default AddressAutocompleteControl;
